<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="airPreferredVendorObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">{{ title }}</p>
          <p>
            Trigger when the airline is not a preferred vendor
            <u> {{ airPreferredVendorObj.value }} </u>
          </p>
        </div>
        <div class="allbtns">
          <b-switch :rounded="true" :value="airPreferredVendorObj.isActive" v-model="airPreferredVendorObj.isActive"
            @input="airPreferredVendor" :left-label="true">{{ airPreferredVendorObj.isActive ? 'Active' : 'Inactive' }}
          </b-switch>
        </div>
      </div>
    </div>
    <StandardRuleActions v-if="airPreferredVendorObj.isActive" :ruleObj="airPreferredVendorObj"
      :title="title" @save="updateActions" />
  </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";

export default {
  name: "",
  props: {
    value: {
      type: [Object],
    },
  },
  components: {
    StandardRuleActions
  },
  data() {
    return {
      airPreferredVendorObj: this.value
        ? this.value
        : {
          name: "airPreferredVendor",
          isActive: false,
          type: "air",
          message: "Airline is not a preferred vendor",
        },
      title: "Airline is not a preferred vendor",
    };
  },
  methods: {
    airPreferredVendor() {
      if (!this.airPreferredVendorObj.isActive) {
        // Clear the custom action parameters when deactivating
        this.clearActionParams();
      }

      this.emitRuleObj();
    },
    clearActionParams() {
      // Reset to default actions when rule is not active ()
      this.airPreferredVendorObj.useCustomActions = false;
      delete this.airPreferredVendorObj.visibility;
      delete this.airPreferredVendorObj.approvalLevel;
      delete this.airPreferredVendorObj.notifications;
    },
    updateActions(updatedRule) {
      // Merge the updated properties into airPreferredVendorObj
      this.airPreferredVendorObj = { ...this.airPreferredVendorObj, ...updatedRule };

      // If useCustomActions is false, delete the associated properties
      if (!updatedRule.useCustomActions) {
        this.clearActionParams()
      }

      this.emitRuleObj();
    },
    emitRuleObj() {
      this.$emit("airPreferredVendor", this.airPreferredVendorObj);
    },
  },
  mounted() {
    this.airPreferredVendorObj.type = "air";

    this.emitRuleObj();
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.airPreferredVendorObj = this.value;
        this.airPreferredVendorObj.type = "air";
        this.emitRuleObj();

      },
      deep: true,
    },
  },
};
</script>
